import Icon from "@ant-design/icons";

const icon = () => (
  <svg
    t="1578467480728"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="25751"
    width="1em"
    height="1em"
  >
    <defs>
      <style type="text/css"></style>
    </defs>
    <path
      d="M0 385.216c5.632 68.032 61.184 121.472 129.088 121.472 63.168 0 115.712-46.4 127.104-107.712 9.856 63.424 63.296 112 127.936 112 63.168 0 115.776-46.4 127.232-107.776 9.728 63.488 63.168 112 127.872 112 63.168 0 115.712-46.464 127.168-107.776 9.792 63.424 63.232 112 127.808 112 71.68 0 129.728-59.52 129.728-132.928l-0.128-1.344H0z m803.2 134.848v416a33.28 33.28 0 0 1-33.408 33.28H254.144a33.28 33.28 0 0 1-33.28-33.28V506.88c-22.528 23.168-53.248 37.76-87.36 38.976v434.816c0 23.936 19.328 43.328 43.264 43.328h670.4a43.328 43.328 0 0 0 43.328-43.328V558.592a127.104 127.104 0 0 1-87.36-38.528z m67.2-430.976S858.88 58.24 813.184 58.24H210.688c-45.696 0-57.152 30.848-57.152 30.848L17.664 348.416h988.544L870.4 89.088zM588.288 911.616a15.616 15.616 0 0 0 22.08 3.968l162.432-117.056a16.448 16.448 0 0 0 3.84-22.592 15.616 15.616 0 0 0-22.016-3.968l-162.496 117.056a16.576 16.576 0 0 0-3.84 22.592z m155.648-68.096l-102.336 68.992a16.448 16.448 0 0 0-4.48 22.464c4.8 7.488 14.592 9.6 21.952 4.672l102.4-68.992a16.448 16.448 0 0 0 4.416-22.528 15.552 15.552 0 0 0-21.952-4.608z"
      fill="#F6BC41"
      p-id="25752"
    ></path>
  </svg>
);

const IconShop = (props) => <Icon component={icon} {...props} />;

export default IconShop;
